<template>
  <b-modal
    id="modalInfo1"
    v-model="isOpen"
    modal-class="modalInfo1"
    :title="$t('label_evaluation_evidencesRequested_removeEvidences')"
  >
    <div class="d-flex justify-content-center">
      <b-form-group v-slot="{ ariaDescribedby }" style="text-align: left">
        <b-form-radio
          v-model="selected"
          :aria-describedby="ariaDescribedby"
          name="some-radios"
          value="unlink"
        >
          {{ $t("label_evaluation_evidencesRequested_removeEvidences_unlink") }}
        </b-form-radio>
        <b-form-radio
          v-model="selected"
          :aria-describedby="ariaDescribedby"
          name="some-radios"
          value="delete"
        >
          {{ $t("label_evaluation_evidencesRequested_removeEvidences_delete") }}
        </b-form-radio>
      </b-form-group>
    </div>
    <div v-if="selected == 'delete'">
      <div class="warning">
        {{
          $t(
            "label_evaluation_evidencesRequested_removeEvidences_delete_warning"
          )
        }}
      </div>
      <div>
        <b-form-checkbox
          v-model="confirmation"
          :value="true"
          :unchecked-value="false"
        >
          {{
            $t(
              "label_evaluation_evidencesRequested_removeEvidences_delete_confirmation"
            )
          }}
        </b-form-checkbox>
      </div>
    </div>

    <div slot="modal-footer" class="w-100" style="text-align: center">
      <b-row class="d-flex justify-content-center">
        <b-col cols="3">
          <b-btn @click="isOpen = false">
            {{ $t("label_evaluation_no_confirmation") }}
          </b-btn>
        </b-col>
        <b-col cols="3">
          <b-btn variant="primary" :disabled="!canSend" @click="confirmAction()">
            {{ $t("label_evaluation_yes_confirmation") }}
          </b-btn>
        </b-col>
      </b-row>
    </div>
  </b-modal>
</template>

<script>
import axios from "axios";
export default {
  name: "EvaluationOrganizationDeleteEvidenceModal",
  props: ["showModal", "evidence", "requirementId"],
  data() {
    return {
      selected: "",
      confirmation: false,
    };
  },
  computed: {
    isOpen: {
      get() {
        return this.showModal;
      },
      set(newValue) {
        this.selected = "";
        this.confirmation = false;
        this.$emit("update:showModal", newValue);
      },
    },

    canSend() {
      if (this.selected == "unlink") {
        return true;
      } else if (this.selected == "delete" && this.confirmation == true) {
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    deleteEvidence: async function () {
      await axios.delete(`/Evidences/${this.evidence._id}`).then(() => {});
    },
    unlinkEvidence: async function () {
      await axios
        .get(
          `/Evidences/unlinkEvidence/${this.evidence._id}/${this.requirementId}`
        )
        .then(() => {});
    },
    confirmAction: async function () {
      if (this.selected == "unlink") {
        await this.unlinkEvidence();
      } else {
        await this.deleteEvidence();
      }
      this.$emit("deleteFile");
      this.isOpen = false;
    },
  },
};
</script>

<style lang="sass" scoped>

.warning
  color: #ff0000
</style>
